import { http } from '@/utils/http'
import { isMp } from '@/utils/platform'

// --- 类型定义 ---

/** upSdk 授权签名信息 */
export interface IUpSdkAuthInfo {
  appId: string
  nonceStr: string
  signature: string
  timestamp: string
  [key: string]: unknown
}

// --- 函数 ---

/**
 * upSdk 授权信息（POST `/unionCloud/login/upSdkAuthInfo`）
 * 与官方 demo 一致：JSON body `{ url: window.location.href }`，不对 url 做 encodeURIComponent。
 */
export function postUpSdkAuthInfo(
  data: { url: string },
  requestOptions?: { hideErrorToast?: boolean },
): Promise<IUpSdkAuthInfo | undefined> {
  const apiPath = isMp
    ? '/unionCloud/login/upSdkAuthInfo'
    : '/api/unionCloud/login/upSdkAuthInfo'

  return http<IUpSdkAuthInfo>({
    url: apiPath,
    method: 'POST',
    data: { url: data.url },
    header: {
      'Content-Type': 'application/json',
    },
    hideErrorToast: requestOptions?.hideErrorToast,
  }).then((res) => {
    if (res.code === 200 && res.data) {
      return res.data
    }
    throw new Error(res.msg || 'upSdkAuthInfo 失败')
  })
}
